import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-list-unordered",
  templateUrl: "./med-icon-list-unordered.component.html",
})
export class MedIconListUnorderedComponent extends SvgMixinComponent {}
